/**
 * The "which rashi is yours?" check's own props on the two daily hubs,
 * /rashifal/ and /hi/aaj-ka-rashifal/, which both render
 * DailyGocharRashifalStudio. Everything the reader sees of the form is reused
 * unchanged: the English words, frame, field ids and no-time explainer are the
 * /rashi/<sign>/ check's (components/rashi/rashi-check-form.ts), and the Hindi
 * card's Hinglish controls are the ones the /hi/rashifal/<sign>/ check used
 * until those pages merged into the hub (rashifal-check-hi-form.ts). Only the
 * analytics placements, the slot's room and the section's id belong to the hubs.
 */

/** free_tool_started and calculator_used placement for the /rashifal/ hub's check. */
export const RASHIFAL_HUB_CHECK_PLACEMENT = "rashifal_hub_page_check";

/** free_tool_started and calculator_used placement for the /hi/aaj-ka-rashifal/ check. */
export const RASHIFAL_HUB_CHECK_HI_PLACEMENT = "hi_rashifal_hub_page_check";

/**
 * The slot's floor in each locale, from the server HTML: the tallest measured
 * state, which every state fills (RashifalHubCheckLazy has the numbers).
 */
export const RASHIFAL_HUB_CHECK_RESERVE = "min-h-[600px] sm:min-h-[500px]";
export const RASHIFAL_HUB_CHECK_HI_RESERVE = "min-h-[560px] sm:min-h-[480px]";

/** The section's id on both hubs: a stable anchor for links and live checks. */
export const RASHIFAL_HUB_CHECK_ID = "which-rashi-is-yours";
